import React from "react";
import "./HelpText.scss";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";

export default function HelpText(props) {
  return (
    <Tooltip
      disableFocusListener
      title={props.helpText}
      key={"helptext_tooltip"}
      enterTouchDelay={0}
    >
      <IconButton aria-label="help" size="large">
        <HelpIcon />
      </IconButton>
    </Tooltip>
  );
}

export function getHelpText(helpText, key) {
  let returnText = "No text found";
  if (!helpText || !Array.isArray(helpText)) {
    return returnText;
  }
  const textObj = helpText.find((item) => item.KEY === key);

  return textObj ? textObj.VALUE : returnText;
}
